import { HttpParams } from '@angular/common/http';

export function getParamFromUrl(url: string, key: string): string | null {
  const params = new HttpParams({ fromString: url });
  return params.get(key);
}
export function encodeUriComponentSafe(arg: string): string;
export function encodeUriComponentSafe(arg: any): any;
export function encodeUriComponentSafe(arg: string | any): string | any {
  if (typeof arg === 'string') {
    return encoreUriStringSafe(arg);
  } else {
    const keys = Object.keys(arg);
    keys.forEach((key) => {
      if (arg.hasOwnProperty(key)) {
        arg[key] = encoreUriStringSafe(arg[key]);
      }
    });

    return arg;
  }
}

function encoreUriStringSafe(prop: string) {
  return prop ? encodeURIComponent(prop) : prop;
}
